import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import imageUrls from '../images/imageUrls';
import { partnerClients } from '../signup-completed-redirection/productLinks';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { redirectToUrl } from '../utils/redirectToUrl';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const AlreadyAPartnerView = () => {
  const portalId = useSelector(getPortalId);
  const hublet = useSelector(getHublet);
  const dispatch = useDispatch();
  const handleButtonClick = useCallback(() => dispatch(redirectToUrl(partnerClients({
    portalId,
    hublet
  }))), [dispatch, hublet, portalId]);
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.AlreadyAPartner,
    handleButtonClick: handleButtonClick,
    imageURL: imageUrls.computerSprocket
  });
};
export default AlreadyAPartnerView;